<template>
  <div
      style="position: fixed;z-index: 999;background-color: #000000E0;top: 0;left: 0"
      v-show="show"
  >
    <div
        class="flex-column justify-content-center align-items-center"
        style="width: 100vw;height: 100vh;"
    >
      <div
          class="flex-column justify-content-start align-items-center"
          style="width: 80%;background-color: #ffffff;border-radius: 0.2rem"
      >
        <div style="width: 100%" class="flex-row justify-content-end">
          <i
              class="el-icon-close"
              style="font-size: 0.6rem;margin: 0.2rem 0.2rem "
              @click="monConfirm"
          ></i>
        </div>
        <div
            class="flex-column justify-content-center align-items-center"
            style="width: 2.4rem;"
        >
          <img v-if="type==='info'" :src="tip" alt="" style="width: 2.4rem;"/>
          <img v-if="type==='warn'" :src="tip" alt="" style="width: 2.4rem;"/>
          <img v-if="type==='error'" :src="tip" alt="" style="width: 2.4rem;"/>
        </div>
        <div
            style="width: 100%;height: auto;"
            class="flex-column justify-content-center align-items-center"
        >
          <div
              style="font-size: 0.4rem;padding: 0.1rem 0.5rem 0.3rem;width: 100%;
            line-break: anywhere;line-height: 0.6rem;text-align: center"
              v-html="message"
          ></div>
        </div>
        <div class="flex-row justify-content-center align-items-center">
          <el-button
              type="primary"
              round
              style="margin-bottom: 0.6rem"
              @click="monConfirm"
          >{{ confirmBtnText }}
          </el-button>
          <el-button
              v-if="cancelBtnText"
              type="danger"
              round
              style="margin-bottom: 0.6rem"
              @click="monConfirm"
          >{{ cancelBtnText }}
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import tip from "@assets/home_new/tip.png";


export default {
  name: "tip",
  components: {},
  props: {
    show: {
      type: Boolean,
      default: false
    },
    isClosed: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: "提示"
    },
    type: {
      type: String,
      default: "warn"//info/error/warn
    },
    tip: {
      type: String,
      default: tip
    },
    message: {
      type: String,
      default: "默认提示信息"
    },
    confirmBtnText: {
      type: String,
      default: "确认"
    },
    cancelBtnText: {
      type: String,
      default: undefined
    },
    onConfirm: {
      type: Function,
      default: function () {

      }
    },
    onCancel: {
      type: Function,
      default: () => {
      }
    },
  },
  data() {
    return {
    };
  },
  created() {
  },
  mounted() {
  },
  destroyed() {
  },
  methods: {
    monConfirm() {
      this.$emit("onConfirm", undefined)
      if (this.isClosed) {
        this.show = false;
      }
      this.remove();
    },
    closed() {
      this.$emit("onCancel", undefined)
      if (this.isClosed) {
        this.show = false;
      }
      this.remove();

    }
  }
};
</script>

<style scoped>
@import "../assets/css/flex.css";

.tip-container {
  width: 100%;
  height: 100%;
  position: relative;
}
</style>
